
import TableBox from '@/components/Box/TableBox'
import ProductItem from '@/components/cart/ProductItem'

export default {
  components: { TableBox, ProductItem },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    thColums() {
      return [
        {
          label: this.data.label,
        },
        {
          label: this.$t('car.price'),
        },
        {
          label: this.$t('car.qty'),
        },
        {
          label: this.$t('car.total'),
        },
        {
          label: '',
        },
      ]
    },
  },
}
